import Clubreg from './modules/clubreg';
import Clubreg2024 from './modules/clubreg2024';
$(function () {
    window.Clubreg = new Clubreg();
    window.Clubreg2024 = new Clubreg2024();
});
